const Social = () => {
	return (

		<div className="social">
			<a
				href="mailto:madnotbadmusic@gmail.com"
				target="_blank"
				rel="noreferrer"
			>
				<i aria-hidden="true" className="fa fa-envelope-o"></i>
			</a>
			<a
				href="https://www.instagram.com/madnotbad_official/"
				target="_blank"
				rel="noreferrer"
			>
				<i aria-hidden="true" className="fa fa-instagram"></i>
			</a>
			<a
				href="https://www.youtube.com/user/mnbodessa"
				target="_blank"
				rel="noreferrer"
			>
				<i
					aria-hidden="true"
					className="fa fa-youtube-square"
				></i>
			</a>
			<a
				href="https://www.facebook.com/madnotbadband/"
				target="_blank"
				rel="noreferrer"
			>
				<i
					aria-hidden="true"
					className="fa fa-facebook-square"
				></i>
			</a>
			<a
				href="https://soundcloud.com/madnotbad"
				target="_blank"
				rel="noreferrer"
			>
				<i aria-hidden="true" className="fa fa-soundcloud"></i>
			</a>
		</div>
	)
}


export default Social;
